import styles from './styles.module.css';
import { Icon } from 'common/icon';
import { Anchor } from 'constants/anchors';
import clsx from 'clsx';
import { useState } from 'react';
import { SelectArrow } from './arrow';

interface FAQItemProps {
  question: string;
  answer: string;
  variant?: 'small' | 'medium';
  className?: string;
}

export const FAQItem = ({
  question,
  answer,
  variant,
  className,
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={clsx(styles.item, className, { [styles.open]: isOpen })}>
      <button
        className={styles.button}
        aria-label="Toggle answer"
        onClick={toggleOpen}
      >
        <Icon.Question />
        <div className={styles.question}>
          <p className={styles.text}>{question}</p>
        </div>
        <div className={styles.arrow}>
          <SelectArrow isOpen={isOpen} size={variant} />
        </div>
      </button>
      <div className={styles.answer}>
        <p>{answer}</p>
      </div>
    </div>
  );
};

const faqData = [
  {
    title: 'Are user ratings moderated?',
    description: 'Yes, all user ratings are moderated.',
  },
  {
    title: 'Will casino representatives see my review?',
    description: 'No, casino representatives will not see your review.',
  },
  {
    title: 'Are the casinos presented on this page safe?',
    description: 'Yes, all casinos presented on this page are safe.',
  },
  {
    title: 'Can all users write their own review?',
    description: 'Yes, all users can write their own review.',
  },
  {
    title: 'Are there casinos with rigged (twisted) games in the ranking?',
    description: 'No, there are no casinos with rigged games in the ranking.',
  },
];

interface FAQComponentProps {
  customFaq?: { title: string; description: string }[];
  titleClassName?: string;
  variant?: 'small' | 'medium';
}

export const FAQComponent = ({
  customFaq,
  titleClassName,
  variant,
}: FAQComponentProps) => {
  if (!customFaq?.length) {
    return null;
  }

  return (
    <div id={Anchor.FAQ} className={styles.container}>
      <h2 className={clsx(styles.title, titleClassName)}>{'FAQ'}</h2>
      <div className={styles.faqContainer}>
        {(customFaq ?? faqData).map((item, index) => (
          <FAQItem
            variant={variant}
            key={index}
            question={item.title}
            answer={item.description}
          />
        ))}
      </div>
    </div>
  );
};
